/*
 * @Author: Yran
 * @Date: 2021-04-23 17:46:53
 * @LastEditors: Yran
 * @LastEditTime: 2021-04-23 18:20:47
 */
import axios from '@/utils/axios';

const apiUrl = {
    materialCostList: '/material/materialData/getMaterialProductDate'
};

// 获取素材成本列表
export function getMaterialCostListData(params) {
    return axios.post(apiUrl.materialCostList, params);
}